import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue';
import mHome from '../views/mobile/mHome.vue';

Vue.use(VueRouter)

const routes = [
  {
    path: '/Home',
    name: 'Home',
    component: Home
  },
  {
    path: '/mHome',
    name: 'mHome',
    component: mHome
  },
  {
    path: '/about',
    name: 'About',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  },
  {
    path: '/Live',
    name: 'Live',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/mobile/Result/Live.vue')
  },
  {
    path: '/GameResult',
    name: 'GameResult',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/mobile/Result/GameResult.vue')
  },
  {
    path: '/Pool',
    name: 'Pool',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/mobile/Result/Pool.vue')
  },
  {
    path: '/Brackets',
    name: 'Brackets',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/mobile/Result/Brackets.vue')
  },
  {
    path: '/Rank',
    name: 'Rank',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/mobile/Medal/Rank.vue')
  },
  {
    path: '/Files',
    name: 'Files',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/mobile/Files/Files.vue')
  },
  {
    path: '/PHome',
    name: 'PHome',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/windows/PHome.vue')
  },
  {
    path: '/Sports',
    name: 'Sports',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/windows/Game/Sports.vue')
  },
  {
    path: '/Games',
    name: 'Games',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/windows/Game/Games.vue'),
    children: [
      {
        // 当 /user/:id/profile 匹配成功
        // UserProfile 将被渲染到 User 的 <router-view> 内部
        path: '/Games/Results',
        component: () => import(/* webpackChunkName: "about" */ '../views/windows/Game/PCResult.vue'),
      },
      {
        path: '/Games/PPool',
        component: () => import(/* webpackChunkName: "about" */ '../views/windows/Game/PPool.vue'),
      },
      {
        path: '/Games/PBrackets',
        component: () => import(/* webpackChunkName: "about" */ '../views/windows/Game/PCBrackets.vue'),
      },
      {
        path: '/Games/PRank',
        component: () => import(/* webpackChunkName: "about" */ '../views/windows/Medal/PRank.vue'),
      },
      {
        path: '/Games/PFiles',
        component: () => import( '../views/windows/File/PFiles.vue'),
      },
      {
        path: "/Games/",
        redirect:'/Games/Results',
      },
      // {
      //   // 当 /user/:id/posts 匹配成功
      //   // UserPosts 将被渲染到 User 的 <router-view> 内部
      //   path: 'posts',
      //   component: UserPosts,
      // },
    ],
  },
  {
    path:"/",
    redirect:'/mHome',
    meta: {
      authen: false
    }
  },
]

const router = new VueRouter({
  routes
})

export default router
